module.exports = __webpack_public_path__ + "img/testroom3platform.1d8f9a9d.png";